require('../../../shared/select2/select2.min');
